
    import './styles.scoped.css';
    export default {
  "treeitem-group": "awsui_treeitem-group_1agpu_gfk1n_9",
  "treeitem": "awsui_treeitem_1agpu_gfk1n_9",
  "offset": "awsui_offset_1agpu_gfk1n_26",
  "treeitem-content-wrapper": "awsui_treeitem-content-wrapper_1agpu_gfk1n_29",
  "tree-item-focus-target": "awsui_tree-item-focus-target_1agpu_gfk1n_34",
  "expand-toggle-wrapper": "awsui_expand-toggle-wrapper_1agpu_gfk1n_55",
  "toggle": "awsui_toggle_1agpu_gfk1n_60",
  "with-icon": "awsui_with-icon_1agpu_gfk1n_66",
  "structured-item-wrapper": "awsui_structured-item-wrapper_1agpu_gfk1n_69",
  "tree-item-structured-item": "awsui_tree-item-structured-item_1agpu_gfk1n_76"
};
  